module.exports = __webpack_public_path__ + "media/newstyle/images/happy-man-using-his-tablet-home-couch_3-ff73ed2a8fab037d6ced8759e026ec1e.png";